import { ExternalLink, MessageSquare, Book, Mail } from 'lucide-react';
import { PageHeader } from '@/components/shared/PageHeader';

const HELP_ITEMS = [
  { icon: Book, title:'Documentation', desc:'Guides, tutorials and feature docs', label:'Open Docs', color:'blue' },
  { icon: MessageSquare, title:'Chat Support', desc:'Talk to our support team', label:'Start Chat', color:'green' },
  { icon: Mail, title:'Email Support', desc:'support@attendx.app · 24h response', label:'Send Email', color:'purple' },
];

export default function HelpPage() {
  return (
    <div className="space-y-5 fade-in max-w-xl">
      <PageHeader title="Help & Support" breadcrumb={[{label:'Settings',href:'/settings'},{label:'Help'}]}/>
      <div className="space-y-3">
        {HELP_ITEMS.map(item=>{
          const Icon = item.icon;
          return (
            <div key={item.title} className="card flex items-center gap-4">
              <div className={`w-10 h-10 rounded-[10px] flex items-center justify-center shrink-0 ${item.color==='blue'?'bg-blue-50 text-[var(--accent)]':item.color==='green'?'bg-green-50 text-[var(--success)]':'bg-purple-50 text-[var(--purple)]'}`}>
                <Icon size={18}/>
              </div>
              <div className="flex-1">
                <p className="text-[14px] font-semibold text-[var(--text-primary)]">{item.title}</p>
                <p className="text-[12px] text-[var(--text-secondary)]">{item.desc}</p>
              </div>
              <button className="text-[12px] font-semibold text-[var(--accent)] flex items-center gap-1 hover:underline">
                {item.label} <ExternalLink size={11}/>
              </button>
            </div>
          );
        })}
      </div>
      <div className="card text-center p-5">
        <p className="text-[13px] text-[var(--text-secondary)]">AttendX v1.0.0 · <a className="text-[var(--accent)]">Terms</a> · <a className="text-[var(--accent)]">Privacy</a></p>
      </div>
    </div>
  );
}
